import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useAuthenticationManager } from "scenes/Authentication/hooks/useAuthenticationManager";

const signInSchema = yup.object({
  email: yup.string().email("Email is invalid").required("Email is required"),
  password: yup.string().required("Password is invalid"),
});

const prepareErrorMessage = (message) => {
  if (message === "User is disabled.")
    return {
      subject: "User Deactivated",
      message:
        "Your account has been deactivated. Please contact support to reactivate.",
    };

  return message || "Failed to sign in";
};

export function useSignInForm({ email = "", password = "" }) {
  const { signIn, isProcessing } = useAuthenticationManager();
  const history = useHistory();

  const [error, setError] = useState();

  const formProps = useForm({
    resolver: yupResolver(signInSchema),
    mode: "onSubmit",
    defaultValues: { email, password },
  });

  return {
    formProps: formProps,
    loading: isProcessing,
    error: error,
    signIn: async ({ email: e, password: p }) => {
      setError("");
      try {
        await signIn(e, p);
      } catch (err) {
        if (err?.name === "UserNotConfirmedException") {
          history.push(`/v2/confirm/${e}`);
          return;
        }
        setError(prepareErrorMessage(err?.message));
      }
    },
  };
}

export default useSignInForm;
